import { render, staticRenderFns } from "./Revenue.vue?vue&type=template&id=66948a41&scoped=true&"
import script from "./Revenue.vue?vue&type=script&lang=js&"
export * from "./Revenue.vue?vue&type=script&lang=js&"
import style0 from "./Revenue.vue?vue&type=style&index=0&id=66948a41&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66948a41",
  null
  
)

export default component.exports